var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8542 37.9166C31.8542 35.903 33.4865 34.2708 35.5 34.2708C37.5135 34.2708 39.1458 35.903 39.1458 37.9166C39.1458 39.9301 37.5135 41.5624 35.5 41.5624C33.4865 41.5624 31.8542 39.9301 31.8542 37.9166Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5 3.64575C26.2377 3.64575 18.7292 11.1543 18.7292 20.4166V23.6649C18.7292 23.8598 18.7546 24.0487 18.8024 24.2285C14.6138 25.7676 11.349 29.1467 9.96376 33.4101C9.25 35.6068 9.25 38.3212 9.25 43.7499C9.25 49.1787 9.25 51.893 9.96376 54.0897C11.4063 58.5295 14.8871 62.0103 19.3268 63.4528C21.5236 64.1666 24.2379 64.1666 29.6666 64.1666H41.3333C46.762 64.1666 49.4765 64.1666 51.6732 63.4528C56.1129 62.0103 59.5937 58.5295 61.0362 54.0897C61.75 51.893 61.75 49.1787 61.75 43.7499C61.75 38.3212 61.75 35.6068 61.0362 33.4101C59.651 29.1467 56.3862 25.7676 52.1976 24.2285C52.2454 24.0487 52.2708 23.8598 52.2708 23.6649V20.4166C52.2708 11.1543 44.7623 3.64575 35.5 3.64575ZM41.3333 23.3333C44.1488 23.3333 46.2341 23.3333 47.8958 23.4328V20.4166C47.8958 13.5706 42.346 8.02075 35.5 8.02075C28.654 8.02075 23.1042 13.5706 23.1042 20.4166V23.4328C24.7659 23.3333 26.8512 23.3333 29.6667 23.3333H41.3333ZM27.4792 37.9166C27.4792 33.4868 31.0702 29.8958 35.5 29.8958C39.9298 29.8958 43.5208 33.4868 43.5208 37.9166C43.5208 41.588 41.0541 44.6833 37.6875 45.6355V55.4166C37.6875 56.6247 36.7081 57.6041 35.5 57.6041C34.2919 57.6041 33.3125 56.6247 33.3125 55.4166V45.6355C29.9459 44.6833 27.4792 41.588 27.4792 37.9166Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6e7db875abdff39e301bf936b04a21f8.svg";
export { ForwardRef as ReactComponent };